

import React, { useEffect, useState } from "react";
import { Timeline } from "primereact/timeline";

import "primereact/resources/themes/saga-blue/theme.css"; // or any other theme you prefer
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import "../../App.css"; // Ensure you import your custom CSS

import { handleEventHistory } from "../../services/routes/eventRoute";

const EventHistory = ({ eventId }) => {

 const [events , setEvents] = useState([])
  const getMeetingHistory = async (id)=>{
    try{
      
      const response = await handleEventHistory(eventId)
      console.log(response)
      setEvents(response)
    }catch(error){
      console.log(error)
    }
  }
 
  useEffect(()=>{
    getMeetingHistory(eventId)
  },[eventId])

 
  
  

  return (
    <div className="bg-white rounded-[10px] border py-5  border-slate-200 w-full  ">
  
      <div className="w-full ">
        <Timeline
          className="px-10 xl:px-1 mt-6"
          value={events}
          opposite={(item) => (
            <small className="text-primary  font-semibold w-full  ">
              {item.time}
            </small>
          )}
          content={(item) => (
            <small className="text-gray-600  font-semibold  ">
              {item.log}
            </small>
          )}
          marker={(item) => (
            <span
              className="w-4 h-4 border-2 border-primary rounded-full bg-white"
            ></span>
          )}
          
        />
      </div>
    </div>
  );
};

export default EventHistory;

